export default __webpack_public_path__ + "static/media/vertical3.4e6ac1dc.jpg";